import { Dropdown, Input, Select, Table } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import svg27 from "../../../assets/svg/svg27.svg";
import DeleteModal from "../../../components/DeleteModal";
import NoDataTable from "../../../components/NoDataTable";
import {
  cleanLeaveBal,
  fetchApprovers,
  fetchLeaveApp,
  fetchLeaveType,
  generateLeaveReport,
} from "../../../features/dropdown/dropdownSlice";
import { deleteLeaveApp } from "../../../features/staff-setting/staffSettingSlice";
import AddLeaveModal from "./modal/AddLeaveModal";
import Search from "../../../components/Search";
import { dateForHumans, formatPath, previewPaper } from "../../../utils";
import TableLoading from "../../../components/TableLoading";
import ApproversModal from "./modal/ApproversModal";

export default function LeaveManagementTable() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { leaveAppl, loading, leaveApplCount } = useSelector(
    (state) => state.dropdown
  );

  const { staffloading } = useSelector((state) => state.staff);

  const [searchText, setSearchText] = useState("");
  const [search, setsearch] = useState("");
  const [activeBtn, setActiveBtn] = useState(null);

  const handleClick = async (item) => {
    await setActiveBtn(item);
  };

  const [open, setopen] = useState(false);

  function handleCancel() {
    setopen(false);
  }
  const [prodd1, setProdd1] = useState("");
  const [openApprovers, setopenApprovers] = useState(false);
  async function handleOpenApprovers() {
    await dispatch(
      fetchApprovers({
        laId: prodd1?.laId,
      })
    );
    await setopenApprovers(true);
  }
  function handleCancelApprovers() {
    setopenApprovers(false);
  }

  const [formData, setFormData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [searchInput, setsearchInput] = useState(null);

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
  };

  const filterDataList = searchInput
    ? leaveAppl?.filter((item) =>
        item?.ltLvtypename?.toLowerCase().includes(searchInput.toLowerCase())
      )
    : leaveAppl;

  const [isModalOpenDelete, setIsModalOpenDelete] = useState(false);
  const showModalDelete = async () => {
    setIsModalOpenDelete(true);
  };
  const handleDelete = async () => {
    const res = await dispatch(
      deleteLeaveApp({
        laId_id: prodd1?.laId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await fetchLeaveAppData();
      await setIsModalOpenDelete(false);
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  const handleEdit = () => {
    setopen(true);
  };

  const settingItemsQuickActions = [
    {
      key: "1",
      label: (
        <Link className="flex  text-[16px] font-sans  !text-lightBlack">
          Medical Leave
        </Link>
      ),
    },
    {
      key: "2",
      label: (
        <Link className="flex  text-[16px] font-sans  !text-lightBlack">
          Casual Leave
        </Link>
      ),
    },
    {
      key: "3",
      label: (
        <Link className="flex  text-[16px] font-sans  !text-lightBlack">
          Annual Leave
        </Link>
      ),
    },
  ];

  const downloadLeaveForm = async () => {
    const res = await dispatch(
      generateLeaveReport({
        laId: prodd1?.laId,
      })
    );
    if (res?.type === "dropdownSlice/generateLeaveReport/fulfilled") {
      const isPDF =
        new TextDecoder().decode(res.payload.slice(0, 4)) === "%PDF";

      const blob = new Blob([res.payload], {
        type: isPDF ? "application/pdf" : "text/csv",
      });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        isPDF ? "leave_application_report.pdf" : "leave_application_report.csv"
      );
      document.body.appendChild(link);
      link.click();

      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
      await toast.success("Generated Successfully");
    } else {
      toast.error("Error generating Report");
    }
  };

  const settingItems = [
    {
      key: "1",
      label: (
        <Link
          onClick={handleEdit}
          className="flex  text-[16px] font-sans  !text-lightBlack"
        >
          Edit
        </Link>
      ),
    },
    {
      key: "2",
      label: (
        <div
          onClick={prodd1?.laApproved === 2 ? showModalDelete : null}
          className={`flex  text-[16px] font-sans   !text-lightBlack ${
            prodd1?.laApproved === 2 ? "cursor-pointer" : "cursor-not-allowed"
          }`}
        >
          Delete
        </div>
      ),
    },
    {
      key: "3",
      label: (
        <div
          onClick={prodd1?.laApproved === 1 ? downloadLeaveForm : null}
          className={`flex  text-[16px] font-sans   !text-lightBlack ${
            prodd1?.laApproved === 1 ? "cursor-pointer" : "cursor-not-allowed"
          }`}
        >
          Download Leave Form
        </div>
      ),
    },
    {
      key: "4",
      label: (
        <div
          onClick={prodd1?.laApproved === 1 ? handleOpenApprovers : null}
          className={`flex  text-[16px] font-sans   !text-lightBlack ${
            prodd1?.laApproved === 1 ? "cursor-pointer" : "cursor-not-allowed"
          }`}
        >
          Approvers
        </div>
      ),
    },
  ];

  const columns = [
    {
      title: "Full Name",
      sorter: (a, b) => a.ppFullname.localeCompare(b.ppFullname),
      dataIndex: "ppFullname",
    },
    {
      title: "LaId",
      sorter: (a, b) => a.laId.localeCompare(b.laId),
      dataIndex: "laId",
    },
    {
      title: "Leave Type",
      sorter: (a, b) => a.ltLvtypename.localeCompare(b.ltLvtypename),
      dataIndex: "ltLvtypename",
    },
    {
      title: "Applied Days",
      dataIndex: "laApldays",
      sorter: (a, b) => a.laApldays.localeCompare - b.laApldays,
    },
    {
      title: "Leave Balance",
      dataIndex: "laBaltotal",
      sorter: (a, b) => a.laBaltotal.localeCompare - b.laBaltotal,
    },
    {
      title: "Substitute",
      sorter: (a, b) => a.laSubstitute.localeCompare(b.laSubstitute),
      dataIndex: "laSubstitute",
    },
    {
      title: "Attachement",
      render: (item) => {
        return (
          <div
            className="cursor-pointer text-[#0000FF]"
            onClick={() => previewPaper(item)}
          >
            {formatPath(item)}
          </div>
        );
      },
      dataIndex: "laAttachmentUrl",
    },
    {
      title: "Start Date",
      sorter: (a, b) => a.laStartdate.localeCompare(b.laStartdate),
      dataIndex: "laStartdate",
      render: (item) => {
        return <div>{dateForHumans(item)}</div>;
      },
    },
    {
      title: "End Date",
      sorter: (a, b) => a.laEnddate.localeCompare(b.laEnddate),
      dataIndex: "laEnddate",
      render: (item) => {
        return <div>{dateForHumans(item)}</div>;
      },
    },
    {
      title: "Return Date",
      sorter: (a, b) => a.laReturndate.localeCompare(b.laReturndate),
      render: (item) => {
        return <div>{dateForHumans(item)}</div>;
      },
      dataIndex: "laReturndate",
    },
    {
      title: "Reason",
      sorter: (a, b) => a.laReason.localeCompare(b.laReason),
      dataIndex: "laReason",
    },
    {
      title: "Approval Comments",
      sorter: (a, b) => a.laComments.localeCompare(b.laComments),
      dataIndex: "laComments",
    },
    {
      title: "Current Level",
      sorter: (a, b) => a.laLevel.localeCompare - b.laLevel,
      dataIndex: "laLevel",
    },
    {
      title: "Approver",
      sorter: (a, b) => a.apr1.localeCompare(b.apr1),
      dataIndex: "apr1",
    },

    {
      title: "Status",
      dataIndex: "laApproved",
      render: (item) => {
        const colors = {
          1: "#2DD683",
          2: "#FFAB00",
          3: "#9D1500",
        };

        return (
          <div
            className="text-[#FFF] inline-block rounded-[5px] px-2 py-1 w-auto"
            style={{
              backgroundColor: colors[item] || "darkGreen",
            }}
          >
            {item === 1
              ? "APPROVED"
              : item === 2
              ? "PENDING"
              : item === 3
              ? "REJECTED"
              : null}
          </div>
        );
      },
    },

    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd1(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];
  const onFinish = () => {};
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchLeaveAppData(page, size) {
    dispatch(
      fetchLeaveApp({
        limit: size ?? pageSize,
        start: page ?? pageIndex,
        laApproved: activeBtn,
      })
    );
  }

  async function fetchLeaveTypeData() {
    await dispatch(fetchLeaveType());
  }

  useEffect(() => {
    fetchLeaveTypeData();
    dispatch(cleanLeaveBal());
  }, []);

  useEffect(() => {
    fetchLeaveAppData();
  }, [activeBtn]);

  if (loading) return <TableLoading />;
  return (
    <div className="">
      <div className="bg-white rounded-[10px] mt-[1.25rem] h-full">
        <div className="flex flex-col w-full lg:px-10 px-3 ">
          <div className="flex lg:flex-row flex-col justify-between  mt-[1.25rem]">
            <div className="flex items-center justify-start  gap-x-5">
              <h3 className="font-[700] text-[24px] text-lightBlack dash-title">
                Leave List
              </h3>
              <span class="py-[.25rem] rounded-[4px] px-[.45rem] font-[600] bg-[#FEF1EB] text-[#F26522]">
                Total Leaves : {leaveApplCount}
              </span>
              {/* <span class="py-[.25rem] rounded-[4px] px-[.45rem] font-[600] bg-[#EDF2F4] text-[#3B7080]">
                Total Remaining Leaves : 32
              </span> */}
            </div>

            <div className="w-[16.8125rem] lg:mt-0 mt-3">
              <Search
                searchInput={searchInput}
                handleSearch={handleSearch}
                text={"Search leave type..."}
              />
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-x-6 gap-y-3 md:gap-x-14 mb-2 w-auto pt-[1rem]">
            <button
              onClick={() => handleClick(null)}
              className={`${
                activeBtn === null
                  ? "text-[#146ADC] border border-[#146ADC]"
                  : ""
              }  !rounded-[4px]   flex items-center gap-x-5 py-1 px-5 font-[500]`}
            >
              <span className="w-[7px] h-[7px] rounded-full bg-[#146ADC]"></span>{" "}
              All
            </button>
            <button
              onClick={() => handleClick("2")}
              className={`${
                activeBtn === "2"
                  ? "text-[#FFAB00] border border-[#FFAB00]"
                  : ""
              }  !rounded-[4px]   flex items-center gap-x-5 py-1 px-5 font-[500]`}
            >
              <span className="w-[7px] h-[7px] rounded-full bg-[#FFAB00]"></span>{" "}
              Pending Leaves
            </button>

            <button
              onClick={() => handleClick("1")}
              className={`${
                activeBtn === "1"
                  ? "text-[#2DD683] border border-[#2DD683]"
                  : ""
              }  !rounded-[4px]   flex items-center gap-x-5 py-1 px-5 font-[500]`}
            >
              <span className="w-[7px] h-[7px] rounded-full bg-[#2DD683]"></span>{" "}
              Approved Leaves
            </button>

            <button
              onClick={() => handleClick("3")}
              className={`${
                activeBtn === "3"
                  ? "text-[#9D1500] border border-[#9D1500]"
                  : ""
              }  !rounded-[4px]   flex items-center gap-x-5 py-1 px-5 font-[500]`}
            >
              <span className="w-[7px] h-[7px] rounded-full bg-[#9D1500]"></span>{" "}
              Rejected/Cancelled Leaves
            </button>
          </div>
          <div className="dash-inner-page mt-[24px] max-w-full w-full overflow-x-auto">
            <section>
              <Table
                rowSelection={false}
                className="mt-[1.31rem] w-full"
                scroll={{
                  x: 800,
                }}
                rowKey={(record) => record?.laId}
                columns={columns}
                dataSource={filterDataList}
                // loading={loading}
                pagination={{
                  position: ["bottomCenter"],
                  current: pageIndex + 1,
                  total: leaveApplCount,
                  pageSize: pageSize,
                  onChange: (page, size) => {
                    setPageIndex(page - 1);
                    setPageSize(size);
                    fetchLeaveAppData(page - 1, size);
                  },
                  showSizeChanger: false,
                  hideOnSinglePage: true,
                }}
              />
            </section>
          </div>
        </div>
      </div>
      <DeleteModal
        isModalOpen={isModalOpenDelete}
        setIsModalOpen={setIsModalOpenDelete}
        prodd={prodd1}
        handleDelete={handleDelete}
        loading={staffloading}
        content={`Are you sure you want to delete leave for ${prodd1?.ppFullname}?`}
        title={`Delete ${prodd1?.ppFullname}`}
      />

      <AddLeaveModal
        handleFetchData={fetchLeaveAppData}
        open={open}
        handleCancel={handleCancel}
        prodd={prodd1}
      />

      <ApproversModal
        handleFetchData={fetchLeaveAppData}
        open={openApprovers}
        handleCancel={handleCancelApprovers}
        prodd={prodd1}
      />
    </div>
  );
}
